"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetFilters = void 0;
const slice_1 = require("../../slice");
const hooks_1 = require("../../../../store/hooks");
const useResetFilters = (listKey) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const onResetFilters = () => {
        dispatch(slice_1.eventsProviderActions.resetFilters({
            listKey,
        }));
    };
    return { onResetFilters };
};
exports.useResetFilters = useResetFilters;
//# sourceMappingURL=useResetFilters.js.map